// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"d1e8e250","256":"b7a59f7c","351":"31d6cfe0","384":"cdda7555","696":"9d7cb4dd","970":"f0760367"}[chunkId] + ".chunk.css";
};